module.exports = __webpack_public_path__ + "static/media/contasiscorp-logo.e1e8106e.webp";